/**
 * TMR App Configuration.
 *
 * Global app configuration data from AppData resources, loaded only once per session.
 * It is the same value in global app state resolved resolved as appConfiguration
 * (@see tmrDefaultAppState), so it's available to route component as binding.
 * Use this service directly (through the `get` method)  only if you don't have access
 * to route resolves.
 *
 * To add values in customizations, decorate the `valuesToResolve` method.
 *
 * @type {ngService}
 */
export class TmrAppConfiguration {
  static ngType = 'service'

  constructor(AppData, UserStorage, $log) {
    'ngInject'
    Object.assign(this, { AppData, UserStorage, $log })
  }

  _values = {}

  valuesToResolve() {
    return {
      'product.image.enabled': { type: 'boolean', defaultValue: false },
      'version.shippingOperations': { type: 'version', defaultValue: '2' },
    }
  }

  format(value, { type, defaultValue }) {
    if (value === undefined) return defaultValue
    if (type === 'boolean') {
      if (value && (value.toLowerCase() === 'true' || value === '1'))
        return true
      if (value && (value.toLowerCase() === 'false' || value === '0'))
        return false
    }
    return value
  }

  resolve() {
    const values = this.valuesToResolve()
    const keys = Object.keys(values)

    if (this.UserStorage.hasCapability('Resource.AppData.list')) {
      this.$promise = this.AppData.getValues(keys).then(appConfiguration => {
        keys.forEach(
          key =>
            (appConfiguration[key] = this.format(
              appConfiguration[key],
              values[key]
            ))
        )
        this._values = appConfiguration
        return appConfiguration
      })
    } else {
      this._values = {}
      keys.forEach(key => (this._values[key] = values[key].defaultValue))
      this.$promise = Promise.resolve(this._values)
      this.$log.warn(
        'User is missing capability Resource.AppData.list. A default configuration is used instead of AppData but it might be wrong'
      )
    }

    return this.$promise
  }

  get(value) {
    return this._values[value]
  }
}
